import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import {useAppDispatch} from '../store/hooks.ts'
import {logout} from '../store/slices/authSlice.ts'
import './Layout.css'
import {useCallback, useEffect, useState} from 'react'
import GearIcon from '@/assets/icons/GearIcon'
import {RootNavPanel, SideNav} from "@fs/uikit-react";

const SystemAdminLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const [arePanelsVisible, setArePanelsVisible] = useState<boolean>(true);

  // Navigate to the first page when entering SystemAdminLayout
  useEffect(() => {
    if (location.pathname === '/system-admin') {
      navigate('/system-admin/settings');
    }
  }, [location.pathname, navigate]);

  // Function to toggle visibility of all panels
  const handleToggleAllPanels = useCallback(() => {
    setArePanelsVisible(prevState => !prevState);
  }, []);

  // Add a keyboard shortcut (Alt+F) to toggle all panels
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.altKey && (event.code === 'KeyF')) {
        handleToggleAllPanels();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleToggleAllPanels]);

  const handleLogout = () => {
    dispatch(logout())
    navigate('/')
  }

  const menuItems = [
    {
      id: 'settings',
      label: 'Налаштування',
      icon: <GearIcon />,
      onClick: () => { navigate('/system-admin/settings'); },
      active: window.location.pathname.startsWith('/system-admin/settings')
    }
  ]

  return (
    <div className="layout system-admin-theme">
      <header className="header">
        <RootNavPanel
          labelText="Системний Адміністратор"
          logoImage={'/logo.svg'}
          className={!arePanelsVisible ? 'fs-root-nav-panel--hidden' : ''}
          onLogout={handleLogout}
        />
      </header>
      <div className="content-container">
        <SideNav 
          menuItems={menuItems} 
          className="system-admin-sidenav"
          collapsed={!arePanelsVisible}
        />
        <main className="main">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default SystemAdminLayout
